<template>
  <div >
    <div class="select-head el-card p-16 mt-24">
      <MyTitle>产业链简介</MyTitle>
      <div class="fx mt-8" v-if="chainDesc">
        {{ chainDesc }}
      </div>
      <EmptyBox v-else class="chain-desc" />
    </div>

    <div class="fx mt-24">
      <div class="mid-card el-card p-16">
        <MyTitle class="mb-16">
          产业政策
          <div slot="right" @click="goPageClick('policy')">查看更多</div>
        </MyTitle>

        <EmptyBox v-if="!policyList.length" />
        <template v-else>
          <TextDocument v-for="(item,i) in policyList" :key="i" :data="item" />
        </template>

      </div>
      <div class="mid-card el-card p-16 ml-24">
        <MyTitle class="mb-16">产业新闻
          <div slot="right" @click="goPageClick('news')">查看更多</div>
        </MyTitle>
        <EmptyBox v-if="!newsList.length" />
        <template v-else>
          <TextDocument v-for="(item,i) in newsList" :key="i" :data="item" news />
        </template>
      </div>
    </div>

    <div class="el-card mt-24 p-16">
      <MyTitle class="mb-16">
        产业链图谱
        <div slot="right" @click="goPageClick('map')">查看完整产业链</div>
      </MyTitle>
      <div>
        <EmptyBox v-if="!hasStream" />

        <div class="stream-header mt-16" v-show="hasStream">
          <div>上游</div>
          <div>中游</div>
          <div>下游</div>
        </div>
        <div ref="container" v-show="hasStream"></div>
      </div>
    </div>

    <div class="el-card mt-24 p-16">
      <MyTitle class="mb-16">
        头部企业
        <div slot="right" @click="goPageClick('distribution')">查看更多企业分布</div>
      </MyTitle>
      <div class="fx-wrap" v-if="classifyOptions.length">
        <CompanyClassify v-for="(item,i) in classifyOptions" :key="i" :data="item" />
      </div>
      <EmptyBox v-else class="chain-desc" />
    </div>

    <div class="el-card mt-24 p-16">
      <MyTitle class="mb-16">
        产业发展趋势
        <div slot="right" @click="goPageClick('analyze')">查看更多产业分析</div>
      </MyTitle>
      <div class="fx-wrap">
        <div class="title pt-1">二级市场·上市公司业务发展趋势</div>
        <MyEcharts ref="chartFirst4" class="w50 h300" />
        <MyEcharts ref="chartFirst5" class="w50 h300" />
        <div class="title">一级市场·投融资趋势</div>
        <MyEcharts ref="chartFirst6" class="w50 h300" />
        <MyEcharts ref="chartFirst7" class="w50 h300" />

      </div>
    </div>

  </div>

</template>

<script>
import CompanyClassify from '@/views/industryChainNew/components/companyClassify'
import MyTitle from '@/views/industryChainNew/components/myTitle'
import MyEcharts from '@/components/myEcharts'
import TextDocument from '@/views/industryChainNew/components/textDocument'
import { D3Tree, StreamsTree, D3Path } from '@/components/D3Tree'
import { levelTwo, companyCountChart, smallPieChart, barChart, pieChart, lineChart } from '../components/echartsOptions'
import { getChainTopCompany, getIndustryChain, getChainAnalysis, getNewsPage, getPolicyChain } from '@/views/industryChainNew/api'
import moment from 'moment'
function getDefaultTime() {
  const now = new Date()
  return [moment(now.getTime() - 3600 * 1000 * 24 * 90).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
}

import { mapState } from 'vuex'
export default {
  name: 'industryOverview',
  components: {
    MyTitle,
    TextDocument,
    CompanyClassify,
    MyEcharts
  },
  props: {

  },
  data() {
    return {
      classifyOptions: [

      ],
      tabOptions: [
        { label: '产业概况', path: 'overview' },
        { label: '产业图谱', path: 'map' },
        { label: '产业分析', path: 'analyze' },
        { label: '企业分布', path: 'distribution' },
        { label: '产业新闻', path: 'news' },
        { label: '产业政策', path: 'policy' },
      ],

      policyList: [],
      newsList: [],
      hasStream: true
    }
  },
  computed: {
    ...mapState({
      chainIDMap: state => state.asyncRoute.chainIDMap,
    }),
    ID() {
      return this.$route?.query?.id
    },
    theChain() {
      return this.chainIDMap[this.ID]
    },
    chainDesc() {
      return this.theChain?.chainDesc
    }
  },
  created() {
  },
  mounted() {
    this.getChainAnalysis()
    this.getIndustryChain()
    this.getNews()
    this.getPolicy()
    this.getChainTopCompany()
  },
  methods: {

    async getIndustryChain() {
      const [err, res] = await this.$reqFn(getIndustryChain, {
        // "isPart": 0,
        // "productNodeCode": "",
        secId: this.ID
      })
      if (res && res.code === 200) {
        const { upStreams, middleStreams, downStreams } = res?.data || {}

        if (upStreams.length || middleStreams.length || downStreams.length) {
          const streamsTree = new StreamsTree(this.$refs.container, {
            height: 400,
            // marginLeft: 120,
            marginTop: 200
          })
          streamsTree.create([upStreams, middleStreams, downStreams])
        } else {
          this.hasStream = false
        }
      }
    },
    async getChainTopCompany() {
      const [err, res] = await this.$reqFn(getChainTopCompany, {
        secId: this.ID
      })
      if (res && res.code === 200) {
        this.classifyOptions = res.data?.list || []
      }
    },
    async getPolicy() {
      const [startDate, endDate] = getDefaultTime()
      const [err, res] = await this.$reqFn(getPolicyChain, {
        pageSize: 5,
        secId: this.ID,
        startDate,
        endDate,
        sort: 2
      })


      if (res && res.code == 200) {
        const { total, policyList } = res.data
        this.policyList = policyList
      }
    },
    async getNews() {
      const [startDate, endDate] = getDefaultTime()

      const [err, res] = await this.$reqFn(getNewsPage, {
        pageSize: 5,
        secId: this.ID,
        startDate,
        endDate
      })
      if (res && res.code == 200 && res.data) {
        const { total, newsList } = res.data
        this.newsList = newsList
      }
    },


    goPageClick(activeName) {
      this.$router.push({ path: `/zxk/industryChain/${activeName}`, query: this.$route.query })
    },

    async getChainAnalysis() {
      const [err, res] = await this.$reqFn(getChainAnalysis, {
        secId: this.ID,
      })
      if (res && res.code === 200) {
        this.analysis = res.data || {}
        this.initCharts()
      }
    },
    initCharts() {
      const {
        companyCount, yearsStatistical,
        regCapitalStatistics, pevcTrendList, takingTrend, grossProfitMargin, technologyTrends,
        patentTypesDistribution, qualCompanyStatistical
      } = this.analysis

      this.$refs.chartFirst4.update(levelTwo(takingTrend, ['全国产品线营业收入', '全国产品线营业收入增速'], '营业收入趋势'))
      this.$refs.chartFirst5.update(levelTwo(grossProfitMargin, ['全国产品线毛利润', '全国产品线毛利润增速'], '毛利润趋势'))


      // debugger
      this.$refs.chartFirst6.update(barChart(pevcTrendList))
      this.$refs.chartFirst6.getChartObj().on('click', params => {
        // 控制台打印数据的名称
        console.log(params.name);
        const res = pevcTrendList.find(e => e.year == params.name)
        const data = pieChart(res)
        this.$refs.chartFirst7.update(data)
      })
      let pieChartData
      for (let index = pevcTrendList.length - 1; index > 0; index--) {
        pieChartData = pevcTrendList[index]
        if (pieChartData.detailList.length) break
      }

      this.$refs.chartFirst7.update(pieChart(pieChartData))

    }
  },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 16px;
  font-weight: 500;
  color: #186bfc;
  padding: 32px 0 16px;
  width: 100%;
}
.h300 {
  height: 300px;
}
.w50 {
  width: 50%;
}
.w25 {
  width: 25%;
}
.select-head {
}
.mid-card {
  width: 50%;
  height: 370px;
}

::v-deep .chain-desc.el-table-emptyImg .empty {
  margin: 0px;
}
::v-deep .el-table-emptyImg .empty {
  margin-top: 30px;
  margin-bottom: 20px;
}
.stream-header {
  display: flex;
  height: 28px;
  flex-direction: row;
  margin-bottom: 20px;
  width: calc(100% - 30px);
  > div {
    flex: 1;
    display: inline-flex;
    align-content: center;
    justify-content: center;
    color: #fff;
    line-height: 28px;
    position: relative;

    &:first-child {
      background: linear-gradient(135deg, #7bbcfe, #357cdf);
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      &::after {
        border-left-color: #357cdf;
      }
    }
    &:nth-child(2) {
      background: linear-gradient(135deg, #43d498, #1eab20);
      &::after {
        border-left-color: #1eab20;
      }
    }
    &:nth-child(3) {
      background: linear-gradient(135deg, #f7b948, #ff7f3e);
      &::after {
        border-left-color: #ff7f3e;
      }
    }

    &::before {
      content: "";
      width: 0;
      height: 0;
      right: -44px;
      top: -8px;
      position: absolute;
      border-top: 22px solid transparent;
      border-bottom: 22px solid transparent;
      border-left: 22px solid #fff;
      border-right: 22px solid transparent;
      z-index: 1;
    }
    &::after {
      content: "";
      width: 0;
      height: 0;
      right: -28px;
      top: 0;
      position: absolute;
      border-top: 14px solid transparent;
      border-bottom: 14px solid transparent;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      z-index: 2;
    }
  }
}
</style>
